import { HttpClient, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { RetrievalDocumentItem } from "./retrieval-document-list-item-model";

@Injectable({
  providedIn: "root",
})
export class RetrievalDocumentListService {

  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient
  ) { }

  getRetrievalDocuments(reqObject: {
    chaseId?: number;
    documentSourceId?: number;
    formType: string;
  }): Observable<any> {

    const {
      chaseId,
      documentSourceId,
      formType,
    } = reqObject;
    let queryString = `?formType=${formType}`;
    if (chaseId) {
      queryString += `&chaseId=${chaseId}`;
    }

    if (documentSourceId) {
      queryString += `&documentSourceId=${documentSourceId}`;
    }
    const url = `${this.baseApiUrl}retrievalDocument${queryString}`;

    return this.http.get(url);
  }

  deleteRetrievalDocument(reqObject: {
    chaseId?: number;
    documentSourceId?: number;
    formType: string;
  }): Observable<any> {

    const url = `${this.baseApiUrl}retrievalDocument`;

    return this.http.request("DELETE", url, {body: reqObject});
  }

}
